<template>
  <ModalComponent :id="id" title="Add User" widthMax="max-w-md">
    <template #body>
      <Form @submit="acceptModal">
        <div class="flex flex-col px-6 py-4">
          <InputWithLabel label="Username *" name="username" />
          <InputWithLabel label="Name *" name="name" />
          <InputWithLabel label="Password *" name="password" type="password" />
          <div class="mb-6">
            <label for="role" class="block mb-2 text-sm font-medium">Role *</label>
            <SelectSearch
              :data="roles"
              optionsValue="label"
              optionsKey="value"
              v-model:formControlName="role"
              placeholder="Select Role"
            />
          </div>
        </div>
        <ModalFooter>
          <template #accept>
            <ButtonComponent :loading="loading">Accept</ButtonComponent>
          </template>
        </ModalFooter>
      </Form>
    </template>
  </ModalComponent>
</template>
<script>
import ButtonComponent from "@/components/ButtonComponent.vue";
import InputWithLabel from "@/components/InputWithLabel.vue";
import ModalComponent from "@/components/ModalComponent.vue";
import ModalFooter from "@/components/ModalFooter.vue";
import SelectSearch from "@/components/SelectSearch.vue";
import axios from "@/config";
import { useErrorStore, useModalStore, useUserStore } from "@/store";
import { Form } from "vee-validate";
import { ref } from "vue";

export default {
  props: {
    id: Number,
  },
  components: {
    ButtonComponent,
    InputWithLabel,
    ModalComponent,
    ModalFooter,
    SelectSearch,
    Form,
  },
  setup() {
    const roles = [
      { label: "User", value: "user" },
      { label: "Admin", value: "admin" },
    ];

    const role = ref("");
    const loading = ref(false);

    const modal = useModalStore();
    const errorStore = useErrorStore();
    const userStore = useUserStore();

    const acceptModal = async (value) => {
      const { username, name, password } = value;
      loading.value = true;

      try {
        await axios.post("user", {
          username: username,
          name: name,
          password: password,
          role: role.value,
        });
        loading.value = false;
        role.value = "";
        userStore.page = 1;
        userStore.offset = 0;
        userStore.q = "";
        modal.closeModal();

        await userStore.getAllUser({});
        userStore.length = userStore.users.count;
      } catch (error) {
        loading.value = false;
        modal.closeModal();
        errorStore.open = true;
        errorStore.retry = false;
        errorStore.message = error.response.data.message;
      }
    };

    return {
      roles,
      role,
      loading,
      acceptModal,
    };
  },
};
</script>
<style></style>
